import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';
import { app } from '../config/app.js';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import {  getPermission } from '../controller/user.js';
import {  getDataByKey } from '../controller/firestore.js';
import { updateDocToDb } from '../controller/firestore.js';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import { getDataFromForm , updatedComputedData } from  '../controller/record.js';
import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import { collection } from 'firebase/firestore';
export default function UpdateRecord(props) {
  const user=props.user;
  const location=useLocation();
  const httpdata = location.state && location.state.data;
  const collectionName=props.collectionName;  
  //const inputDoc=(httpdata.docData?httpdata.docData:null);
  
  const id=(httpdata ? (httpdata.id?httpdata.id:null) : null);
  const callerUrl=httpdata.callerUrl;
  const activePermission=getPermission("collection",collectionName,null,user);
  
  const title=(id?"Aggiorna":"Aggiungi")+" "+app.collections_config[collectionName].singleLabel;
  const [viewConfig,setViewConfig]=useState(app.collections_config[collectionName].views.update);
  const [formClosed,setFormClosed] =useState(false);
  const [errorMessage,setErrorMessage] =useState("");
  const getEditableElements = (valueElements) => {
    let ee={};
    for (let i=0;i<viewConfig.fieldList.length;i++) {
      const gridElement=viewConfig.fieldList[i];
      let editable=true;
      if (gridElement.field==="id") {
        if (gridElement.showOnNew && !id)
          editable=true;
        else
          editable=false;
      }
      if (editable && gridElement.disabled!==undefined) editable=!gridElement.disabled;
      if (editable && gridElement.editable_func!==undefined) {
        const asyncRequired=app.services[gridElement.editable_func].async;     
        
        if (!asyncRequired) editable=app.services[gridElement.editable_func].func(collectionName,viewConfig,gridElement,valueElements,valueElements[gridElement.field],activePermission,user);
        
      }
      if (gridElement.debug) console.log("Editable "+gridElement.field+"?",editable);
      ee[gridElement.field]=editable;
    }
    return ee;
  }
  let isLoadingTable={};
  useEffect(() => {
    
    const fetchData = async () => {
      const params = {
        "where":["id", "==", id],
        "pagination":false
      }
      if (viewConfig.debug)
        console.log("Fetch data id",id);
      //if (inputDoc==null) 
      //else console.log("Salto fetch data id perchè ho già documento",inputDoc.data);
      //const doc=(inputDoc!=null?inputDoc.data:await getDataByKey(collectionName,id));
      const doc=await getDataByKey(collectionName,id);
      
      let valueElements={};
      for (let i=0;i<viewConfig.fieldList.length;i++) {
        const gridElement=viewConfig.fieldList[i];
        if (gridElement.field==="id")
          valueElements[gridElement.field]=id;  
        else
          valueElements[gridElement.field]=(doc?doc[gridElement.field]:null);
        if (gridElement.type==="datetime") {
          if (gridElement.debug)
            console.log("Got datetime ",valueElements[gridElement.field]);
          if (valueElements[gridElement.field]===undefined || typeof(valueElements[gridElement.field].toDate)!=="function")
            valueElements[gridElement.field]=null;
          else
            valueElements[gridElement.field]=valueElements[gridElement.field].toDate();
        }
        if (gridElement.type==="date") {
          if (gridElement.debug)
            console.log("Got date ",valueElements[gridElement.field]);
          if (valueElements[gridElement.field]===undefined || typeof(valueElements[gridElement.field].toDate)!=="function")
            valueElements[gridElement.field]=null;
          else
            valueElements[gridElement.field]=valueElements[gridElement.field].toDate();
        }
        if (!valueElements[gridElement.field]) valueElements[gridElement.field]="";
      }
      if (valueElements.id===undefined) valueElements.id=id;
      
      editableElements=getEditableElements(valueElements);
      
      if (viewConfig.debug)
        console.log("New form data",valueElements);
      
      console.log("New form data",valueElements);
      setFormData({"values":valueElements,"editableElements":editableElements});
      
    };
    if (isLoadingTable[id]) return;
    isLoadingTable[id]=true;
    if (id) fetchData();
  }, []);
  let valueElements={};
  for (let i=0;i<viewConfig.fieldList.length;i++) {
    const gridElement=viewConfig.fieldList[i];
    let value=null;
    if (gridElement.debug===true) console.log("Init Step 0 "+gridElement.field+" value:",value);
    if (value===null && gridElement.default!==undefined && gridElement.default!==null) 
      value=gridElement.default;
      if (gridElement.debug===true) console.log("Init Step 1 "+gridElement.field+" value:",value);
    if (value===null && gridElement.default_function!==undefined) {
      const asyncRequired=app.services[gridElement.default_function].async;     
      
      if (!asyncRequired) value=app.services[gridElement.default_function].func(gridElement,value);
    }
    if (gridElement.debug===true) console.log("Init Step 2 "+gridElement.field+" value:",value);
    if (value===null||value===undefined) value="";
    if (gridElement.debug===true) console.log("Init Step 3 "+gridElement.field+" value:",value);
    valueElements[gridElement.field]=value;

  }
  
  let editableElements=getEditableElements(valueElements);
  const formTemp={
    "values":valueElements,
    "editableElements":editableElements
  };
  const [formData,setFormData]=useState(formTemp);
  
  const handleChangeData= (item,value) => {
    let curForm=formData;
    curForm.values[item.field]=value;
    if (item.onSet!=null) {
      if (item.onSet.computedFields!=null) {
        curForm.values=updatedComputedData(collectionName,item,item.onSet.computedFields,curForm.values);
      }
    }
    setFormData({...curForm});
  
  };
  async function  handleSubmitForm(event) {
 
    
    event.preventDefault();
    console.log("Valori input form",formData.values);
    const data=getDataFromForm(collection,viewConfig,formData.values);
    console.log("Valori salvati",data);
    try {
      const esito=await updateDocToDb(collectionName,viewConfig,id,data);
      if (viewConfig.debug)
        console.log("Esito update/add",(esito[0]?'OK':'KO'));
      if (!esito[0]) setErrorMessage(esito[1]);
      setFormClosed(esito[0]);
    } catch (error) {
      setErrorMessage(error);
    }
  }
  const actionText=(id?"Aggiorna":"Inserisci");
  return (
    <React.Fragment>
      {formClosed ?
      <Navigate to={callerUrl} /> :
      <form onSubmit={handleSubmitForm}>
        {errorMessage!=="" && <Alert severity="error">{errorMessage}</Alert> }
      <Typography sx={{pb:2}} variant="h6" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={3}>
      {formData && viewConfig.fieldList.map( gridElement => (
        gridElement.showOnNew!==false ?(<Grid item key={gridElement.field} {...gridElement.gridProp}>

            <RenderItem key={gridElement.field} item={gridElement} value={formData.values[gridElement.field]} editable={formData.editableElements[gridElement.field]} handleChangeData={handleChangeData} />
        </Grid>) : null

      ))}
      
      </Grid>
      <Stack sx={{mt:2}} align="right" direction="row" spacing={2}>
        <Button  component={Link} to={callerUrl} variant="contained">Chiudi</Button>
        <Button  type="submit" color="success" variant="contained">{actionText}</Button>
      </Stack>
      </form>}
    </React.Fragment>
  );
}
function RenderItem({item,value,handleChangeData,editable}) {
  const [asyncOptionData, setAsyncOptionData] = useState(null);
  
  let asyncRequired=false;
  
  
  function changedValue(e) {
    let curValue=null;
    if (e!=null) {
      if (e.$isDayjsObject) 
        curValue=e.$d;
      else 
        curValue=e.target.value;
    }
    if (editable===true) {
    //  setValueInput(curValue);
      handleChangeData(item,curValue);
    }
  };
  const labelId=item.field+"-label";
  useEffect(() => {
    async function fetchData() {
      try {
        const obtainedData=await app.services[item.option_service]["func"](item,value);
        setAsyncOptionData(obtainedData);
        
      } catch (error) {
        console.error('Errore nella chiamata asincrona', error);
        
      }
    }
    if (asyncRequired && asyncOptionData===null)
      fetchData(); // Esegui la chiamata asincrona solo una volta all'avvio del componente
  }, []); 
  useEffect(() => {
    console.log("Use effect nuovo valore",value);
  }, [value]);

    
  //const [valueInput, setValueInput] = useState(value);
  if (item.debug) console.log("Value input "+item.field,value);
  if (item.hidden) {
    return <input type='hidden' {...item.textProp}  value={value} required={item.required} id={item.field} name={item.field} label={item.headerName} />;
  }
  let renderType=item.type;
  if (!editable) {
    renderType="text";
  }
  
    switch (renderType) {
      case 'select':
        let options=item.options;
        
        if (item.option_service) { 
          
          asyncRequired=app.services[item.option_service].async;
          if (!asyncRequired) options=app.services[item.option_service].func(item,value);
        }
        
        return ( 
        <FormControl fullWidth>
        <InputLabel id={labelId}>{item.headerName}{item.required ? '*':''}</InputLabel>
        <Select fullWidth {...item.textProp} editable={editable.toString()} onChange={changedValue} variant="outlined" required={item.required} labelId={labelId} id={item.field} name={item.field} label={item.headerName} value={value}>
          {
            asyncRequired ? 
              (
                (
                  asyncOptionData ===null ? 
                  (
                    <div>Loading</div>
                  )  :
                  (
                
                    asyncOptionData.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === value}>{option.label}</MenuItem>               
                    ))

                  )
                )
              ) : (
                (
                  options ===null ? 
                  (
                    
                    <div>Loading synced</div>
                  ):
                  (
                    options.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === value}>{option.label}</MenuItem>               
                    ))
                  )
                )
              )
          }
          </Select></FormControl>);
      case 'boolean':
        return <FormControl fullWidth><TextField  fullWidth {...item.textProp} onChange={changedValue} variant="standard" required={item.required} id={item.field} name={item.field} label={item.headerName}/></FormControl>;
      case 'date':
        return  <FormControl fullWidth><DateField  onChange={changedValue} variant="outlined" label={item.headerName} {...item.textProp} required={item.required} id={item.field} name={item.field} value={(value!=""?dayjs(value):null)}  /></FormControl>;
      case 'datetime':
        return  <FormControl fullWidth><DateTimeField  onChange={changedValue} variant="outlined" label={item.headerName} {...item.textProp} required={item.required} id={item.field} name={item.field} value={(value!=""?dayjs(value):null)}  /></FormControl>;
      
      default:
        return <TextField fullWidth {...item.textProp} onChange={changedValue} variant="outlined" value={value} required={item.required} id={item.field} name={item.field} label={item.headerName} disabled={!editable} />;
    }
  
}